import { datadogRum } from '@datadog/browser-rum';

export const rumWrapperStartView = (key: string, _name: string, _context?: object) =>
  datadogRum.startView(key);

// this isn't implemented for web in DD for some reason. not a big issue since web is insignificant.
export const rumWrapperStopView = (key: string) => {};
